// const BASE_URL = "http://162.19.146.135:1678/node_api/";
// const BASE_URL = "http://192.168.9.47:5011/node_api/";
// const BASE_URL = "http://192.168.10.40:1678/node_api/";
// const BASE_URL = "http://208.109.215.160:5000/";
const BASE_URL = "https://admin.spcuniversity.com/node_api/";
// const BASE_URL = "https://yucef.admin.iossmlm.com/node_api/"
// const BASE_URL = "http://localhost:5000/node_api/";

// const BASE_URL = "https://yusef.admin.infinitemlmdemo.com/node_api/";
// const DEFAULT_KEY = 'k2MPvSjDLYupMkF63g1EJRwGJTpp0RVLIF22WN6Em2FwlJe9EaONYKb6dUdkTMevQjPUnmwP9gH'
const DEFAULT_KEY = 'k2MPvSjDLYupMkF63g1EJRwGJTpp0RVLIF22WN6Em2FwlJe9EaONYKb6dUdkTMevQjPUnmw43RU6cWFCaCPsuP9gH'


// const PAYPAL_CLIENT_ID = "ASvJulHqV3V9Z6jxjQJWpTnb4L2XtqtsMriic0AwU7s6iroMu4BPbv37YV3C6n9wdG1giiZ6VeL8P-er"
// const PAYPAL_CLIENT_ID = "AYanNMG1zaLU0Y5oK7kaBmhQsLopp9fvOvWjFE1DatHBidbqaRWPvblrjOHVblmXZFNnRz9OjIhq_7Q2"
// const PAYPAL_CLIENT_ID = 'AfI2pQmFdPYGVCmBfdhjNmZ7MCiAsogYqUswdWbk3oATC8p84p839QBK-XI-QZfI5848C-4RfwhFWrU8'


//live
const PAYPAL_CLIENT_ID = 'AScSy3Ps_HvIpL17XUIHrmqseRxHAg1Utqycp0nlvByVqwkUJAs8opHAh91hU-kJ29jWKUtYr35TBTjJ'

//demo
// const PAYPAL_CLIENT_ID = 'AfI2pQmFdPYGVCmBfdhjNmZ7MCiAsogYqUswdWbk3oATC8p84p839QBK-XI-QZfI5848C-4RfwhFWrU8'

// akhila 
// const PAYPAL_CLIENT_ID = "AfI2pQmFdPYGVCmBfdhjNmZ7MCiAsogYqUswdWbk3oATC8p84p839QBK-XI-QZfI5848C-4RfwhFWrU8"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID } 